<template>
  <div class="admin-page">
    <Header />

    <div class="admin-container">
      <div class="admin-header">
        <h1 class="admin-title">Painel Administrativo</h1>
        <div class="header-actions">
          <div class="menu-dropdown" @click.stop="toggleMenu">
            <button class="btn-menu">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 6h16M4 12h16M4 18h16"/>
              </svg>
              Menu
            </button>
            <div v-if="menuAberto" class="dropdown-content" @click.stop>
              <router-link to="/admin/controle" class="dropdown-item" @click.native="menuAberto = false">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="3" width="7" height="7"/>
                  <rect x="14" y="3" width="7" height="7"/>
                  <rect x="14" y="14" width="7" height="7"/>
                  <rect x="3" y="14" width="7" height="7"/>
                </svg>
                Controle
              </router-link>
              <button @click="abrirGerenciarUsuarios" class="dropdown-item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
                Gerenciar Usuários
              </button>
              <button @click="abrirAlterarSenha" class="dropdown-item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
                Alterar Senha
              </button>
              <button @click="abrirTabItensPlano" class="dropdown-item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 6h16M4 12h16M4 18h10"/>
                  <path d="M8 6v12"/>
                </svg>
                Itens de Plano
              </button>
            </div>
          </div>
          <button @click="logout" class="btn-logout">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1"
              />
            </svg>
            Sair
          </button>
        </div>
      </div>

      <div class="admin-tabs">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          class="tab-btn"
          :class="{ active: tabAtiva === tab.id }"
          @click="tabAtiva = tab.id"
        >
          {{ tab.label }}
        </button>
      </div>

      <!-- Cadastro de Categorias -->
      <div v-if="tabAtiva === 'categorias'" class="admin-content">
        <h2 class="section-title">Cadastro de Categorias</h2>

        <form @submit.prevent="salvarCategoria" class="admin-form">
          <div class="form-group">
            <label>Descrição</label>
            <input
              v-model="categoriaForm.descricao"
              type="text"
              required
              class="form-input"
            />
          </div>

          <div class="form-group">
            <label>
              <input v-model="categoriaForm.ativo" type="checkbox" />
              Ativo
            </label>
          </div>

          <div class="form-actions">
            <button type="submit" class="btn-save">
              {{ editandoCategoria ? 'Atualizar Categoria' : 'Salvar Categoria' }}
            </button>
            <button
              v-if="editandoCategoria"
              type="button"
              class="btn-cancel"
              @click="cancelarEdicaoCategoria"
            >
              Cancelar
            </button>
          </div>
        </form>

        <div class="table-container">
          <div class="table-controls">
            <input
              type="search"
              v-model="buscaCategoria"
              @input="paginaCategoria = 1"
              placeholder="Buscar categoria por ID ou descrição..."
              class="search-input"
            />
            <label class="toggle-container">
              <span class="toggle-label">{{
                "Ocultar inativos"
              }}</span>
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="ocultarInativosCategoria"
                  @change="paginaCategoria = 1"
                />
                <span class="slider"></span>
              </label>
            </label>
          </div>
          <table class="admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Descrição</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="cat in categoriasPaginadas" :key="cat.id">
                <td>{{ cat.id }}</td>
                <td>
                  {{ cat.descricao }}
                  <span
                    v-if="cat.ativo === false"
                    class="status-chip status-inativo"
                  >
                    Inativo
                  </span>
                </td>
                <td>{{ cat.ativo ? "Ativo" : "Inativo" }}</td>
                <td>
                  <button @click="editarCategoria(cat)" class="btn-edit">
                    Editar
                  </button>
                </td>
              </tr>
              <tr v-if="categoriasPaginadas.length === 0">
                <td colspan="4" class="text-center text-muted">
                  Nenhuma categoria encontrada.
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="totalPaginasCategorias > 1" class="pagination">
            <button
              @click="paginaCategoria--"
              :disabled="paginaCategoria === 1"
              class="btn-pagination"
            >
              Anterior
            </button>
            <span class="pagination-info">
              Página {{ paginaCategoria }} de {{ totalPaginasCategorias }}
            </span>
            <button
              @click="paginaCategoria++"
              :disabled="paginaCategoria === totalPaginasCategorias"
              class="btn-pagination"
            >
              Próxima
            </button>
          </div>
        </div>
      </div>

      <!-- Cadastro de Produtos -->
      <div v-if="tabAtiva === 'produtos'" class="admin-content">
        <h2 class="section-title">Cadastro de Produtos</h2>

        <form @submit.prevent="salvarProduto" class="admin-form">
          <div class="form-row">
            <div class="form-group">
              <label>Nome</label>
              <input
                v-model="produtoForm.nome"
                type="text"
                required
                class="form-input"
              />
            </div>

            <div class="form-group">
              <label>Tipo</label>
              <input
                v-model="produtoForm.tipo"
                type="text"
                required
                class="form-input"
              />
            </div>
          </div>

          <div class="form-group">
            <label>Descrição</label>
            <textarea
              v-model="produtoForm.descricao"
              required
              class="form-input form-textarea"
              rows="4"
            ></textarea>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Valor</label>
              <input
                v-model.number="produtoForm.valor"
                type="number"
                step="0.01"
                required
                class="form-input"
              />
            </div>

            <div class="form-group">
              <label>Quantidade em Estoque</label>
              <input
                v-model.number="produtoForm.qtdEstoque"
                type="number"
                required
                class="form-input"
              />
            </div>

           
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Fornecedor</label>
              <input
                v-model="produtoForm.fornecedor"
                type="text"
                required
                class="form-input"
              />
            </div>
            <div class="form-group">
              <label>Categoria</label>
              <select
                v-model.number="produtoForm.categoriaId"
                required
                class="form-input"
              >
                <option value="">Selecione...</option>
                <option v-for="cat in categorias" :key="cat.id" :value="cat.id">
                  {{ cat.descricao }}
                </option>
              </select>
            </div>
          </div>

          <!-- Switch Categorizar Agregados -->
          <div class="form-group">
            <label class="switch-label">
              <label class="switch">
                <input
                  v-model="produtoForm.categorizarAgregados"
                  type="checkbox"
                />
                <span class="slider"></span>
              </label>
              <span>Categorizar agregados</span>
            </label>
          </div>

          <!-- Campos de Agregados (aparecem quando o switch está ativo) -->
          <div v-if="produtoForm.categorizarAgregados" class="agregados-section">
            <h4 class="section-title">Configuração de Agregados</h4>

            <!-- Agregado 1 -->
            <div class="form-row">
              <div class="form-group">
                <label>Agregado 1</label>
                <select
                  v-model.number="produtoForm.itemAgregado1Id"
                  class="form-input"
                >
                  <option value="">Selecione um produto...</option>
                  <option v-for="prod in produtosAtivos" :key="prod.id" :value="prod.id">
                    {{ prod.nome }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Idade max Agregado 1</label>
                <input
                  v-model.number="produtoForm.idadeMaxAgregado1"
                  type="number"
                  min="0"
                  max="1000"
                  class="form-input"
                />
              </div>
            </div>

            <!-- Agregado 2 -->
            <div class="form-row">
              <div class="form-group">
                <label>Agregado 2</label>
                <select
                  v-model.number="produtoForm.itemAgregado2Id"
                  class="form-input"
                >
                  <option value="">Selecione um produto...</option>
                  <option v-for="prod in produtosAtivos" :key="prod.id" :value="prod.id">
                    {{ prod.nome }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Idade max Agregado 2</label>
                <input
                  v-model.number="produtoForm.idadeMaxAgregado2"
                  type="number"
                  min="0"
                  max="1000"
                  class="form-input"
                />
              </div>
            </div>

            <!-- Agregado 3 -->
            <div class="form-row">
              <div class="form-group">
                <label>Agregado 3</label>
                <select
                  v-model.number="produtoForm.itemAgregado3Id"
                  class="form-input"
                >
                  <option value="">Selecione um produto...</option>
                  <option v-for="prod in produtosAtivos" :key="prod.id" :value="prod.id">
                    {{ prod.nome }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Idade max Agregado 3</label>
                <input
                  v-model.number="produtoForm.idadeMaxAgregado3"
                  type="number"
                  min="0"
                  max="1000"
                  class="form-input"
                />
              </div>
            </div>
          </div>

          <div class="form-group">
            <label>Imagem do Produto (opcional)</label>
            <input
              type="file"
              accept="image/*"
              @change="onImageChange"
              class="form-input"
              ref="fileInput"
            />
            <div v-if="produtoForm.imagemPreview" class="image-preview">
              <img :src="produtoForm.imagemPreview" alt="Preview" />
              <button
                type="button"
                @click="removerImagem"
                class="btn-remove-image"
              >
                Remover
              </button>
            </div>
          </div>

          <div class="form-row form-row-checkboxes">
            <div class="form-group">
              <label>
                <input v-model="produtoForm.ativo" type="checkbox" />
                Ativo
              </label>
            </div>
            <div class="form-group">
              <label>
                <input v-model="produtoForm.destaque" type="checkbox" />
                Destaque
              </label>
            </div>
            <div class="form-group">
              <label class="switch-label">
                
                <label class="switch">
                  <input
                    v-model="produtoForm.planoFunerario"
                    type="checkbox"
                    @change="onPlanoFunerarioChange"
                  />
                  <span class="slider"></span>
                </label>
                <span>Plano Funerário</span>
              </label>
            </div>
          </div>

          <div class="form-row form-row-checkboxes">
            <div class="form-group">
              <label class="switch-label" title="Cliente escolhe entre retirada no local ou colocação em jazigo durante o checkout">
                <label class="switch">
                  <input 
                    v-model="produtoForm.habilitarRetirada" 
                    type="checkbox"
                    :disabled="produtoForm.planoFunerario"
                    @change="handleHabilitarRetiradaChange"
                  />
                  <span class="slider"></span>
                </label>
                <span :class="{ 'switch-text-muted': produtoForm.planoFunerario }">Habilitar Retirada</span>
                <svg class="info-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="#6b7280" stroke-width="2"/>
                  <path d="M12 16V12M12 8H12.01" stroke="#6b7280" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </label>
            </div>
            <div class="form-group">
              <label class="switch-label" title="Cliente seleciona uma pessoa falecida do cemitério e adiciona uma mensagem durante o checkout">
                <label class="switch">
                  <input 
                    v-model="produtoForm.vincularFalecido" 
                    type="checkbox"
                    :disabled="produtoForm.planoFunerario"
                    @change="handleVincularFalecidoChange"
                  />
                  <span class="slider"></span>
                </label>
                <span :class="{ 'switch-text-muted': produtoForm.planoFunerario }">Vincular Falecido</span>
                <svg class="info-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="#6b7280" stroke-width="2"/>
                  <path d="M12 16V12M12 8H12.01" stroke="#6b7280" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </label>
            </div>
          </div>

          <div v-if="produtoForm.planoFunerario" class="form-row">
            <div class="form-group">
              <label>Quantidade de Dependentes</label>
              <select v-model="produtoForm.qtdDependentes" class="form-input">
                <option value="">Selecione...</option>
                <option v-for="n in 16" :key="'dep-qtd-' + n" :value="n - 1">
                  {{ n - 1 }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Idade Máxima do Dependente</label>
              <select v-model="produtoForm.idadeMaxDependente" class="form-input">
                <option value="">Selecione...</option>
                <option v-for="n in 100" :key="'dep-idade-' + n" :value="n">
                  {{ n }}
                </option>
              </select>
            </div>
          </div>

          <div v-if="produtoForm.planoFunerario" class="form-row">
            <div class="form-group">
              <label>Quantidade de agregados</label>
              <select v-model="produtoForm.qtdAgregados" class="form-input">
                <option value="">Selecione...</option>
                <option v-for="n in 16" :key="'agg-qtd-' + n" :value="n - 1">
                  {{ n - 1 }}
                </option>
              </select>
            </div>
          </div>

          <div v-if="produtoForm.planoFunerario" class="form-group">
            <label>Itens do plano</label>
            <div v-if="itensPlano.length" class="roles-checkboxes itens-plano-checkboxes">
              <label
                v-for="item in itensPlano"
                :key="item.id"
                class="checkbox-label"
              >
                <input
                  type="checkbox"
                  :value="item.id"
                  v-model="produtoForm.itensPlanoIds"
                />
                <span>
                  {{ item.descricao }}
                  <span v-if="item.destaque" class="item-destaque-mark" title="Destaque">★</span>
                </span>
              </label>
            </div>
            <p v-else class="field-hint">
              Nenhum item de plano cadastrado. Use a aba <strong>Itens de Plano</strong> para incluir opções.
            </p>
          </div>

          <div class="form-actions">
            <button type="submit" class="btn-save">
              {{ editandoProduto ? 'Atualizar Produto' : 'Salvar Produto' }}
            </button>
            <button
              v-if="editandoProduto"
              type="button"
              class="btn-cancel"
              @click="cancelarEdicaoProduto"
            >
              Cancelar
            </button>
          </div>
        </form>

        <div class="table-container">
          <div class="table-controls">
            <input
              type="search"
              v-model="buscaProduto"
              @input="paginaProduto = 1"
              placeholder="Buscar produto por ID, nome ou descrição..."
              class="search-input"
            />
            <label class="toggle-container">
              <span class="toggle-label">{{
                "Ocultar inativos"
              }}</span>
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="ocultarInativosProduto"
                  @change="paginaProduto = 1"
                />
                <span class="slider"></span>
              </label>
            </label>
          </div>
          <table class="admin-table">
            <thead>
              <tr>
                <th class="sortable" @click="ordenarPor('id')">
                  ID
                  <span class="sort-icon">
                    <svg
                      v-if="ordenacaoProdutos.campo !== 'id'"
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 10L12 15L17 10"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <svg
                      v-else-if="ordenacaoProdutos.direcao === 'asc'"
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 14L12 9L17 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <svg
                      v-else
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 10L12 15L17 10"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </th>
                <th class="sortable" @click="ordenarPor('nome')">
                  Nome
                  <span class="sort-icon">
                    <svg
                      v-if="ordenacaoProdutos.campo !== 'nome'"
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 10L12 15L17 10"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <svg
                      v-else-if="ordenacaoProdutos.direcao === 'asc'"
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 14L12 9L17 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <svg
                      v-else
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 10L12 15L17 10"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </th>
                <th class="sortable" @click="ordenarPor('valor')">
                  Valor
                  <span class="sort-icon">
                    <svg
                      v-if="ordenacaoProdutos.campo !== 'valor'"
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 10L12 15L17 10"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <svg
                      v-else-if="ordenacaoProdutos.direcao === 'asc'"
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 14L12 9L17 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <svg
                      v-else
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 10L12 15L17 10"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </th>
                <th class="sortable" @click="ordenarPor('qtdEstoque')">
                  Estoque
                  <span class="sort-icon">
                    <svg
                      v-if="ordenacaoProdutos.campo !== 'qtdEstoque'"
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 10L12 15L17 10"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <svg
                      v-else-if="ordenacaoProdutos.direcao === 'asc'"
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 14L12 9L17 14"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <svg
                      v-else
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 10L12 15L17 10"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </th>
                <th>Categoria</th>
                <th class="col-destaque"></th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="prod in produtosPaginados" :key="prod.id">
                <td>{{ prod.id }}</td>
                <td>
                  {{ prod.nome || prod.descricao }}
                  <span
                    v-if="prod.ativo === false"
                    class="status-chip status-inativo"
                  >
                    Inativo
                  </span>
                </td>
                <td>R$ {{ formatPrice(prod.valor) }}</td>
                <td>{{ prod.qtdEstoque }}</td>
                <td>{{ getNomeCategoria(prod.categoriaId) }}</td>
                <td class="col-destaque">
                  <span v-if="prod.destaque" class="destaque-star" title="Destaque">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                    </svg>
                  </span>
                </td>
                <td>
                  <button @click="editarProduto(prod)" class="btn-edit">
                    Editar
                  </button>
                </td>
              </tr>
              <tr v-if="produtosPaginados.length === 0">
                <td colspan="7" class="text-center text-muted">
                  Nenhum produto encontrado.
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="totalPaginasProdutos > 1" class="pagination">
            <button
              @click="paginaProduto--"
              :disabled="paginaProduto === 1"
              class="btn-pagination"
            >
              Anterior
            </button>
            <span class="pagination-info">
              Página {{ paginaProduto }} de {{ totalPaginasProdutos }}
            </span>
            <button
              @click="paginaProduto++"
              :disabled="paginaProduto === totalPaginasProdutos"
              class="btn-pagination"
            >
              Próxima
            </button>
          </div>
        </div>
      </div>

      <!-- Itens de Plano -->
      <div v-if="tabAtiva === 'itens-plano'" class="admin-content">
        <h2 class="section-title">Itens de Plano</h2>
        <p class="section-subtitle">
          Cadastre os itens que compõem ou descrevem os planos (benefícios, coberturas, etc.).
        </p>

        <form @submit.prevent="salvarItemPlano" class="admin-form">
          <div class="form-group">
            <label>Descrição</label>
            <input
              v-model="itemPlanoForm.descricao"
              type="text"
              required
              class="form-input"
              placeholder="Ex.: Seguro de vida R$ 1.500"
            />
          </div>

          <div class="form-group">
            <label>
              <input v-model="itemPlanoForm.destaque" type="checkbox" />
              Destaque
            </label>
          </div>

          <div class="form-actions">
            <button type="submit" class="btn-save">
              {{ editandoItemPlano ? 'Atualizar item' : 'Salvar item' }}
            </button>
            <button
              v-if="editandoItemPlano"
              type="button"
              class="btn-cancel"
              @click="cancelarEdicaoItemPlano"
            >
              Cancelar
            </button>
          </div>
        </form>

        <div class="table-container">
          <table class="admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Descrição</th>
                <th>Destaque</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in itensPlano" :key="item.id">
                <td>{{ item.id }}</td>
                <td>{{ item.descricao }}</td>
                <td>{{ item.destaque ? 'Sim' : 'Não' }}</td>
                <td>
                  <button type="button" class="btn-edit" @click="editarItemPlano(item)">
                    Editar
                  </button>
                </td>
              </tr>
              <tr v-if="!carregandoItensPlano && itensPlano.length === 0">
                <td colspan="4" class="text-center text-muted">
                  Nenhum item cadastrado.
                </td>
              </tr>
              <tr v-if="carregandoItensPlano">
                <td colspan="4" class="text-center text-muted">
                  Carregando itens...
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    <!-- Dialog -->
    <Dialog
      :show="dialog.show"
      :titulo="dialog.titulo"
      :mensagem="dialog.mensagem"
      :tipo="dialog.tipo"
      :botao-texto="dialog.botaoTexto"
      @confirm="onDialogConfirm"
      @close="fecharDialog"
    />

      <!-- Listagem de Vendas -->
      <div v-if="tabAtiva === 'vendas'" class="admin-content">
        <h2 class="section-title">Listagem de Vendas</h2>

        <div v-if="carregando" class="loading-container">
          <div class="spinner"></div>
          <p class="loading-text">Carregando vendas...</p>
        </div>

        <div v-else class="table-container">
          <input
            type="search"
            v-model="buscaVenda"
            @input="paginaVenda = 1"
            placeholder="Buscar venda por ID, cliente ou ID de pagamento..."
            class="search-input margin-bottom"
          />
          <table class="admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Data</th>
                <th>Valor Total</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="venda in vendasPaginadas" :key="venda.id">
                <td>{{ venda.id }}</td>
                <td>{{ formatDate(venda.dataVenda) }}</td>
                <td>R$ {{ formatPrice(venda.valorTotal) }}</td>
                <td>
                  <span
                    :class="`status-badge status-${venda.status.toLowerCase()}`"
                  >
                    {{ venda.status ? venda.status.replace("_", " ") : "" }}
                  </span>
                </td>
                <td>
                  <button @click="verDetalhesVenda(venda)" class="btn-view">
                    Ver Detalhes
                  </button>
                </td>
              </tr>
              <tr v-if="vendasPaginadas.length === 0">
                <td colspan="5" class="text-center text-muted">
                  Nenhuma venda encontrada.
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="totalPaginasVendas > 1" class="pagination">
            <button
              @click="paginaVenda--"
              :disabled="paginaVenda === 1"
              class="btn-pagination"
            >
              Anterior
            </button>
            <span class="pagination-info">
              Página {{ paginaVenda }} de {{ totalPaginasVendas }}
            </span>
            <button
              @click="paginaVenda++"
              :disabled="paginaVenda === totalPaginasVendas"
              class="btn-pagination"
            >
              Próxima
            </button>
          </div>
        </div>
      </div>

      <!-- Controle de Pedidos -->
      <div v-if="tabAtiva === 'controle-pedidos'" class="admin-content">
        <h2 class="section-title">Controle de Pedidos</h2>
        <p class="section-subtitle">Vendas com status PAGO</p>

        <div class="table-container">
          <table class="admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Data</th>
                <th>Cliente</th>
                <th>Valor Total</th>
                <th>Forma de Pagamento</th>
                <th>Status do Pedido</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="venda in vendasPagas">
                <tr :key="`venda-${venda.id}`">
                  <td>{{ venda.id }}</td>
                  <td>{{ formatDate(venda.dataVenda) }}</td>
                  <td>
                    <div v-if="venda.clienteNome">
                      <div><strong>{{ venda.clienteNome }}</strong></div>
                      <div class="text-muted">{{ venda.clienteEmail || venda.clienteTelefone || '-' }}</div>
                    </div>
                    <span v-else class="text-muted">-</span>
                  </td>
                  <td>R$ {{ formatPrice(venda.valorTotal) }}</td>
                  <td>
                    <span v-if="venda.formaPagamento || venda.forma_pagamento" class="status-badge status-pago">
                      {{ getLabelFormaPagamento(venda.formaPagamento || venda.forma_pagamento) }}
                    </span>
                    <span v-else class="text-muted">-</span>
                  </td>
                  <td>
                    <span v-if="venda.statusVenda || venda.status_venda" class="status-badge" :class="getStatusPedidoClass(venda.statusVenda || venda.status_venda)">
                      {{ getLabelStatusPedido(venda.statusVenda || venda.status_venda) }}
                    </span>
                    <span v-else class="text-muted">-</span>
                  </td>
                  <td>
                    <button @click="editarStatusPedido(venda)" class="btn-edit">
                      Editar Status
                    </button>
                  </td>
                </tr>
                <tr v-if="venda.itens && venda.itens.length > 0" :key="`itens-${venda.id}`" class="itens-row">
                  <td colspan="7" class="itens-cell">
                    <div class="itens-container">
                      <h4 class="itens-title">Itens do Pedido:</h4>
                      <div class="itens-list">
                        <div v-for="(item, index) in venda.itens" :key="index" class="item-card">
                          <div class="item-header">
                            <span class="item-nome"><strong>{{ item.nomeProduto }}</strong></span>
                            <span class="item-quantidade">Qtd: {{ item.quantidade }}</span>
                          </div>
                          <div class="item-details">
                            <div class="item-info">
                              <span class="item-label">Valor Unitário:</span>
                              <span class="item-value">R$ {{ formatPrice(item.valorUnitario) }}</span>
                            </div>
                            <div class="item-info">
                              <span class="item-label">Valor Total:</span>
                              <span class="item-value item-total">R$ {{ formatPrice(item.valorTotal) }}</span>
                            </div>
                          </div>
                          <div v-if="item.detalhes" class="item-detalhes">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span><strong>Detalhes:</strong> {{ item.detalhes }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
              <tr v-if="vendasPagas.length === 0">
                <td colspan="7" class="text-center text-muted">
                  Nenhuma venda com status PAGO encontrada.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Modal de Edição de Status -->
        <div v-if="editandoStatusPedido" class="modal-overlay" @click="cancelarEdicaoStatusPedido">
          <div class="modal-content" @click.stop>
            <div class="modal-header">
              <h3>Editar Status do Pedido #{{ editandoStatusPedido.id }}</h3>
              <button @click="cancelarEdicaoStatusPedido" class="btn-close-modal">×</button>
            </div>
            <form @submit.prevent="salvarStatusPedido" class="admin-form">
              <div class="form-group">
                <label>Status da Venda</label>
                <select
                  v-model="statusPedidoForm.statusVenda"
                  required
                  class="form-input"
                >
                  <option value="">Selecione...</option>
                  <option v-for="opcao in opcoesStatusPedido" :key="opcao.value" :value="opcao.value">
                    {{ opcao.label }}
                  </option>
                </select>
              </div>

              <div class="form-actions">
                <button type="submit" class="btn-save">
                  Salvar
                </button>
                <button
                  type="button"
                  class="btn-cancel"
                  @click="cancelarEdicaoStatusPedido"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal de Gerenciar Usuários -->
    <div v-if="modalGerenciarUsuarios" class="modal-overlay modal-large" @click="fecharModalGerenciarUsuarios">
      <div class="modal-content modal-large-content" @click.stop>
        <div class="modal-header">
          <h3>Gerenciamento de Usuários</h3>
          <div class="modal-header-actions">
            <button @click="abrirCadastroUsuario" class="btn-save" style="margin-right: 8px;">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width: 16px; height: 16px; margin-right: 4px;">
                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="8.5" cy="7" r="4"/>
                <path d="M20 8v6M23 11h-6"/>
              </svg>
              Cadastrar Usuário
            </button>
            <button @click="fecharModalGerenciarUsuarios" class="btn-close-modal">×</button>
          </div>
        </div>
        <div class="modal-body">
          <div class="table-container">
            <table class="admin-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Username</th>
                  <th>Nome</th>
                  <th>Email</th>
                  <th>Telefone</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="usuario in usuarios" :key="usuario.id">
                  <td>{{ usuario.id }}</td>
                  <td>{{ usuario.username }}</td>
                  <td>{{ usuario.nome }}</td>
                  <td>{{ usuario.email }}</td>
                  <td>{{ usuario.telefone || '-' }}</td>
                  <td>
                    <span :class="`status-badge ${usuario.ativo ? 'status-pago' : 'status-inativo'}`">
                      {{ usuario.ativo ? 'Ativo' : 'Inativo' }}
                    </span>
                  </td>
                  <td>
                    <div class="action-buttons">
                      <button @click="alterarStatusUsuario(usuario)" class="btn-edit">
                        {{ usuario.ativo ? 'Inativar' : 'Ativar' }}
                      </button>
                      <button @click="abrirModalPermissoes(usuario)" class="btn-edit" style="margin-left: 8px;">
                        Atualizar Permissões
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="usuarios.length === 0 && !carregandoUsuarios">
                  <td colspan="7" class="text-center text-muted">
                    Nenhum usuário encontrado.
                  </td>
                </tr>
                <tr v-if="carregandoUsuarios">
                  <td colspan="7" class="text-center text-muted">
                    Carregando usuários...
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Cadastro de Usuário -->
    <div v-if="modalCadastroUsuario" class="modal-overlay" @click="fecharModalCadastroUsuario">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Cadastrar Usuário</h3>
          <button @click="fecharModalCadastroUsuario" class="btn-close-modal">×</button>
        </div>
        <form @submit.prevent="salvarUsuario" class="admin-form">
          <div class="form-group">
            <label>Username *</label>
            <input v-model="usuarioForm.username" type="text" required class="form-input" />
          </div>
          <div class="form-group">
            <label>Nome *</label>
            <input v-model="usuarioForm.nome" type="text" required class="form-input" />
          </div>
          <div class="form-group">
            <label>Email *</label>
            <input v-model="usuarioForm.email" type="email" required class="form-input" />
          </div>
          <div class="form-group">
            <label>Telefone</label>
            <input v-model="usuarioForm.telefone" type="text" class="form-input" />
          </div>
          <div class="form-group">
            <label>Senha *</label>
            <input v-model="usuarioForm.senha" type="password" required class="form-input" />
          </div>
          <div class="form-group">
            <label>Permissões (Roles) *</label>
            <div class="roles-checkboxes">
              <label v-for="role in roles" :key="role.id" class="checkbox-label">
                <input 
                  type="checkbox" 
                  :value="role.id" 
                  v-model="usuarioForm.roleIds"
                />
                <span>{{ role.nome || role.name || role.descricao || `Role ${role.id}` }}</span>
              </label>
            </div>
            <p v-if="roles.length === 0" class="text-muted">Carregando permissões...</p>
          </div>
          <div class="form-group">
            <label>
              <input v-model="usuarioForm.ativo" type="checkbox" />
              Ativo
            </label>
          </div>
          <div class="form-actions">
            <button type="submit" class="btn-save">Salvar</button>
            <button type="button" class="btn-cancel" @click="fecharModalCadastroUsuario">Cancelar</button>
          </div>
        </form>
      </div>
    </div>

    <!-- Modal de Alterar Senha -->
    <div v-if="modalAlterarSenha" class="modal-overlay" @click="fecharModalAlterarSenha">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Alterar Senha</h3>
          <button @click="fecharModalAlterarSenha" class="btn-close-modal">×</button>
        </div>
        <form @submit.prevent="salvarNovaSenha" class="admin-form">
          <div class="form-group">
            <label>Senha Atual *</label>
            <input v-model="senhaForm.senhaAtual" type="password" required class="form-input" />
          </div>
          <div class="form-group">
            <label>Nova Senha *</label>
            <input v-model="senhaForm.novaSenha" type="password" required class="form-input" />
          </div>
          <div class="form-group">
            <label>Confirmar Nova Senha *</label>
            <input v-model="senhaForm.confirmarSenha" type="password" required class="form-input" />
          </div>
          <div class="form-actions">
            <button type="submit" class="btn-save">Alterar Senha</button>
            <button type="button" class="btn-cancel" @click="fecharModalAlterarSenha">Cancelar</button>
          </div>
        </form>
      </div>
    </div>

    <!-- Modal de Atualizar Permissões -->
    <div v-if="modalAtualizarPermissoes" class="modal-overlay" @click="fecharModalPermissoes">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Atualizar Permissões do Usuário</h3>
          <button @click="fecharModalPermissoes" class="btn-close-modal">×</button>
        </div>
        <form @submit.prevent="salvarPermissoes" class="admin-form">
          <div class="form-group">
            <label>Permissões (Roles) *</label>
            <div class="roles-checkboxes">
              <label v-for="role in roles" :key="role.id" class="checkbox-label">
                <input 
                  type="checkbox" 
                  :value="role.id" 
                  v-model="permissoesForm.roleIds"
                />
                <span>{{ role.nome || role.name || role.descricao || `Role ${role.id}` }}</span>
              </label>
            </div>
            <p v-if="roles.length === 0" class="text-muted">Carregando permissões...</p>
          </div>
          <div class="form-actions">
            <button type="submit" class="btn-save">Salvar Permissões</button>
            <button type="button" class="btn-cancel" @click="fecharModalPermissoes">Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Dialog from "../components/Dialog.vue";
import categoriaService from "../services/categoriaService";
import produtoService from "../services/produtoService";
import vendaService from "../services/vendaService";
import authService from "../services/authService";
import usuarioService from "../services/usuarioService";
import roleService from "../services/roleService";
import itemPlanoService from "../services/itemPlanoService";

export default {
  name: "Admin",
  components: {
    Header,
    Dialog,
  },
  data() {
    return {
      tabAtiva: "categorias",
      tabs: [
        { id: "categorias", label: "Categorias" },
        { id: "produtos", label: "Produtos" },
        { id: "itens-plano", label: "Itens de Plano" },
        { id: "vendas", label: "Vendas" },
        { id: "controle-pedidos", label: "Controle de Pedidos" },
      ],
      categorias: [],
      produtos: [],
      vendas: [],
      usuarios: [],
      roles: [],
      carregandoUsuarios: false,
      carregandoRoles: false,
      menuAberto: false,
      modalGerenciarUsuarios: false,
      modalCadastroUsuario: false,
      modalAlterarSenha: false,
      modalAtualizarPermissoes: false,
      usuarioForm: {
        username: "",
        nome: "",
        email: "",
        telefone: "",
        senha: "",
        ativo: true,
        roleIds: [],
      },
      senhaForm: {
        senhaAtual: "",
        novaSenha: "",
        confirmarSenha: "",
      },
      permissoesForm: {
        usuarioId: null,
        roleIds: [],
      },
      ordenacaoProdutos: {
        campo: null,
        direcao: "asc", // 'asc' ou 'desc'
      },
      buscaCategoria: "",
      paginaCategoria: 1,
      itensPorPaginaCategoria: 10,
      ocultarInativosCategoria: true,
      buscaProduto: "",
      paginaProduto: 1,
      itensPorPaginaProduto: 10,
      ocultarInativosProduto: true,
      buscaVenda: "",
      paginaVenda: 1,
      itensPorPaginaVenda: 10,
      categoriaForm: {
        descricao: "",
        ativo: true,
      },
      produtoForm: {
        nome: "",
        descricao: "",
        tipo: "",
        valor: 0,
        qtdEstoque: 0,
        fornecedor: "",
        categoriaId: null,
        imagem: null,
        imagemPreview: null,
        imagemFile: null,
        ativo: true,
        destaque: false,
        planoFunerario: false,
        qtdDependentes: "",
        idadeMaxDependente: "",
        itensPlanoIds: [],
        qtdAgregados: "",
        habilitarRetirada: false,
        vincularFalecido: false,
        categorizarAgregados: false,
        itemAgregado1Id: null,
        idadeMaxAgregado1: "",
        itemAgregado2Id: null,
        idadeMaxAgregado2: "",
        itemAgregado3Id: null,
        idadeMaxAgregado3: "",
      },
      dialog: {
        show: false,
        titulo: "",
        mensagem: "",
        tipo: "alert",
        botaoTexto: "OK",
      },
      editandoCategoria: null,
      editandoProduto: null,
      itensPlano: [],
      itemPlanoForm: {
        descricao: "",
        destaque: false,
      },
      editandoItemPlano: null,
      carregandoItensPlano: false,
      carregando: false,
      editandoStatusPedido: null,
      statusPedidoForm: {
        statusVenda: "",
      },
      opcoesStatusPedido: [
        { value: "em Análise", label: "em Análise" },
        { value: "Em Produção", label: "Em Produção" },
        { value: "Produto Finalizado", label: "Produto Finalizado" },
        { value: "Entregue", label: "Entregue" },
        { value: "Enviado ao Jázigo/Capela", label: "Enviado ao Jázigo/Capela" },
      ],
      opcoesFormaPagamento: [
        { value: "credit_card", label: "Cartão de Crédito" },
        { value: "debit_card", label: "Cartão de Débito" },
        { value: "pix", label: "PIX" },
        { value: "boleto", label: "Boleto" },
        { value: "cash", label: "Dinheiro" },
        // Compatibilidade com valores antigos
        { value: "CARTAO_CREDITO", label: "Cartão de Crédito" },
        { value: "CARTAO_DEBITO", label: "Cartão de Débito" },
        { value: "PIX", label: "PIX" },
        { value: "BOLETO", label: "Boleto" },
        { value: "DINHEIRO", label: "Dinheiro" },
      ],
    };
  },
  computed: {
    produtosAtivos() {
      return this.produtos
        .filter(prod => prod.ativo !== false)
        .sort((a, b) => a.nome.localeCompare(b.nome));
    },
    vendasPagas() {
      return this.vendas
        .filter(venda => venda.status === "PAGO")
        .sort((a, b) => b.id - a.id);
    },
    categoriasFiltradas() {
      let resultado = [...this.categorias];
      if (this.ocultarInativosCategoria) {
        resultado = resultado.filter(cat => cat.ativo !== false);
      }
      if (this.buscaCategoria) {
        const busca = this.buscaCategoria.toLowerCase();
        resultado = resultado.filter(
          cat =>
            cat.descricao.toLowerCase().includes(busca) ||
            cat.id.toString().includes(busca)
        );
      }
      resultado.sort((a, b) => b.id - a.id);
      return resultado;
    },
    categoriasPaginadas() {
      const inicio = (this.paginaCategoria - 1) * this.itensPorPaginaCategoria;
      const fim = inicio + this.itensPorPaginaCategoria;
      return this.categoriasFiltradas.slice(inicio, fim);
    },
    totalPaginasCategorias() {
      return Math.ceil(
        this.categoriasFiltradas.length / this.itensPorPaginaCategoria
      );
    },
    produtosFiltrados() {
      let resultado = [...this.produtos];
      if (this.ocultarInativosProduto) {
        resultado = resultado.filter(prod => prod.ativo !== false);
      }
      if (this.buscaProduto) {
        const busca = this.buscaProduto.toLowerCase();
        resultado = resultado.filter(
          prod =>
            prod.nome.toLowerCase().includes(busca) ||
            prod.id.toString().includes(busca) ||
            (prod.descricao && prod.descricao.toLowerCase().includes(busca))
        );
      }
      return resultado;
    },
    produtosOrdenados() {
      let resultado = [...this.produtosFiltrados];
      if (!this.ordenacaoProdutos.campo) {
        resultado.sort((a, b) => b.id - a.id);
        return resultado;
      }
      const campo = this.ordenacaoProdutos.campo;
      const direcao = this.ordenacaoProdutos.direcao;
      return resultado.sort((a, b) => {
        let valorA = a[campo];
        let valorB = b[campo];
        if (typeof valorA === "string") {
          valorA = valorA.toLowerCase();
          valorB = valorB.toLowerCase();
        }
        if (valorA < valorB) return direcao === "asc" ? -1 : 1;
        if (valorA > valorB) return direcao === "asc" ? 1 : -1;
        return 0;
      });
    },
    produtosPaginados() {
      const inicio = (this.paginaProduto - 1) * this.itensPorPaginaProduto;
      const fim = inicio + this.itensPorPaginaProduto;
      return this.produtosOrdenados.slice(inicio, fim);
    },
    totalPaginasProdutos() {
      return Math.ceil(
        this.produtosOrdenados.length / this.itensPorPaginaProduto
      );
    },
    vendasFiltradas() {
      let resultado = [...this.vendas];
      if (this.buscaVenda) {
        const busca = this.buscaVenda.toLowerCase();
        resultado = resultado.filter(
          venda =>
            venda.id.toString().includes(busca) ||
            (venda.clienteNome &&
              venda.clienteNome.toLowerCase().includes(busca)) ||
            (venda.idPagamentoExterno &&
              venda.idPagamentoExterno.toLowerCase().includes(busca))
        );
      }
      resultado.sort((a, b) => b.id - a.id);
      return resultado;
    },
    vendasPaginadas() {
      const inicio = (this.paginaVenda - 1) * this.itensPorPaginaVenda;
      const fim = inicio + this.itensPorPaginaVenda;
      return this.vendasFiltradas.slice(inicio, fim);
    },
    totalPaginasVendas() {
      return Math.ceil(
        this.vendasFiltradas.length / this.itensPorPaginaVenda
      );
    },
  },
  mounted() {
    if (!authService.isAuthenticated()) {
      this.$router.push("/login");
      return;
    }
    this.carregarDados();
    // Fechar menu ao clicar fora
    document.addEventListener('click', this.fecharMenuAoClicarFora);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.fecharMenuAoClicarFora);
  },
  watch: {},
  methods: {
    ordenarPor(campo) {
      if (this.ordenacaoProdutos.campo === campo) {
        // Se já está ordenando por este campo, inverte a direção
        this.ordenacaoProdutos.direcao =
          this.ordenacaoProdutos.direcao === "asc" ? "desc" : "asc";
      } else {
        // Novo campo, começa com ascendente
        this.ordenacaoProdutos.campo = campo;
        this.ordenacaoProdutos.direcao = "asc";
      }
    },
    async carregarDados() {
      this.carregando = true;
      try {
        // Na tela de cadastro, usamos as rotas que trazem dados com inativos
        this.categorias = await categoriaService.listarCategoriasComInativasPorEmpresa();
        this.produtos = await produtoService.listarProdutosComInativosPorEmpresa();
        this.vendas = await vendaService.listarVendas();
        await this.carregarItensPlano();
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
        if (error.response?.status === 403) {
          authService.logout();
          this.$router.push("/login");
          return;
        }
        this.mostrarDialog("Erro", error.response?.data?.mensagem || "Erro ao carregar dados. Verifique sua conexão.");
      } finally {
        this.carregando = false;
      }
    },
    async carregarItensPlano() {
      this.carregandoItensPlano = true;
      try {
        this.itensPlano = await itemPlanoService.listar();
      } catch (error) {
        console.error("Erro ao carregar itens de plano:", error);
        this.itensPlano = [];
        if (error.response?.status !== 403) {
          this.mostrarDialog(
            "Erro",
            error.response?.data?.mensagem || "Não foi possível carregar os itens de plano."
          );
        }
      } finally {
        this.carregandoItensPlano = false;
      }
    },
    async salvarItemPlano() {
      try {
        const payload = {
          descricao: this.itemPlanoForm.descricao.trim(),
          destaque: Boolean(this.itemPlanoForm.destaque),
        };
        if (this.editandoItemPlano) {
          await itemPlanoService.atualizar(this.editandoItemPlano.id, payload);
        } else {
          await itemPlanoService.criar(payload);
        }
        this.itemPlanoForm = { descricao: "", destaque: false };
        this.editandoItemPlano = null;
        await this.carregarItensPlano();
        this.mostrarDialog("Sucesso", "Item de plano salvo com sucesso!");
      } catch (error) {
        this.mostrarDialog(
          "Erro",
          error.response?.data?.mensagem ||
            error.response?.data?.message ||
            "Erro ao salvar item de plano."
        );
      }
    },
    editarItemPlano(item) {
      this.itemPlanoForm = {
        descricao: item.descricao || "",
        destaque: Boolean(item.destaque),
      };
      this.editandoItemPlano = item;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    cancelarEdicaoItemPlano() {
      this.itemPlanoForm = { descricao: "", destaque: false };
      this.editandoItemPlano = null;
    },
    async salvarCategoria() {
      try {
        if (this.editandoCategoria) {
          await categoriaService.atualizarCategoria(
            this.editandoCategoria.id,
            this.categoriaForm,
          );
        } else {
          await categoriaService.criarCategoria(this.categoriaForm);
        }
        this.categoriaForm = { descricao: "", ativo: true };
        this.editandoCategoria = null;
        await this.carregarDados();
        this.mostrarDialog("Sucesso", "Categoria salva com sucesso!");
      } catch (error) {
        this.mostrarDialog(
          "Erro",
          error.response?.data?.mensagem || error.message || "Erro ao salvar categoria."
        );
      }
    },
    async salvarProduto() {
      try {
        // Monta o DTO do produto sem base64, incluindo empresaId
        const produtoDto = {
          nome: this.produtoForm.nome,
          descricao: this.produtoForm.descricao,
          tipo: this.produtoForm.tipo,
          valor: this.produtoForm.valor,
          qtdEstoque: this.produtoForm.qtdEstoque,
          fornecedor: this.produtoForm.fornecedor,
          categoriaId: this.produtoForm.categoriaId,
          empresaId: 3,
          imagem: null, // não enviar base64
          ativo: this.produtoForm.ativo,
          destaque: this.produtoForm.destaque,
          planoFunerario: this.produtoForm.planoFunerario,
          qtdDependentes: this.normalizarNumeroOpcionalProduto(this.produtoForm.qtdDependentes),
          idadeMaxDependente: this.normalizarNumeroOpcionalProduto(this.produtoForm.idadeMaxDependente),
          habilitarRetirada: this.produtoForm.planoFunerario
            ? false
            : this.produtoForm.habilitarRetirada,
          vincularFalecido: this.produtoForm.planoFunerario
            ? false
            : this.produtoForm.vincularFalecido,
          itensPlanoIds: this.normalizarItensPlanoIdsParaEnvio(),
          qtdAgregados: this.normalizarNumeroOpcionalProduto(this.produtoForm.qtdAgregados),
          itemAgregado1Id: this.produtoForm.itemAgregado1Id || null,
          idadeMaxAgregado1: this.normalizarNumeroOpcionalProduto(this.produtoForm.idadeMaxAgregado1),
          itemAgregado2Id: this.produtoForm.itemAgregado2Id || null,
          idadeMaxAgregado2: this.normalizarNumeroOpcionalProduto(this.produtoForm.idadeMaxAgregado2),
          itemAgregado3Id: this.produtoForm.itemAgregado3Id || null,
          idadeMaxAgregado3: this.normalizarNumeroOpcionalProduto(this.produtoForm.idadeMaxAgregado3),
        };

        if (this.editandoProduto) {
          // Atualiza dados do produto (JSON)
          await produtoService.atualizarProduto(
            this.editandoProduto.id,
            produtoDto,
          );

          // Se tiver nova imagem, chama o endpoint específico de imagem
          if (this.produtoForm.imagemFile) {
            await produtoService.atualizarImagem(
              this.editandoProduto.id,
              this.produtoForm.imagemFile,
            );
          }
        } else {
          // Criação: se tiver imagem, usar FormData; senão, usar JSON
          if (this.produtoForm.imagemFile) {
            const formData = new FormData();
            formData.append(
              "produto",
              new Blob([JSON.stringify(produtoDto)], {
                type: "application/json",
              })
            );
            formData.append("file", this.produtoForm.imagemFile);
            await produtoService.criarProduto(formData);
          } else {
            // Sem imagem: enviar apenas JSON
            await produtoService.criarProdutoJson(produtoDto);
          }
        }
        this.produtoForm = {
          nome: "",
          descricao: "",
          tipo: "",
          valor: 0,
          qtdEstoque: 0,
          fornecedor: "",
          categoriaId: null,
          imagem: null,
          imagemPreview: null,
          imagemFile: null,
          ativo: true,
          destaque: false,
          planoFunerario: false,
          qtdDependentes: "",
          idadeMaxDependente: "",
          itensPlanoIds: [],
          qtdAgregados: "",
          habilitarRetirada: false,
          vincularFalecido: false,
          categorizarAgregados: false,
          itemAgregado1Id: null,
          idadeMaxAgregado1: "",
          itemAgregado2Id: null,
          idadeMaxAgregado2: "",
          itemAgregado3Id: null,
          idadeMaxAgregado3: "",
        };
        this.removerImagem();
        this.editandoProduto = null;
        await this.carregarDados();
        this.mostrarDialog("Sucesso", "Produto salvo com sucesso!");
      } catch (error) {
        this.mostrarDialog(
          "Erro",
          error.response?.data?.mensagem || error.message || "Erro ao salvar produto."
        );
      }
    },
    editarCategoria(categoria) {
      this.categoriaForm = { ...categoria };
      this.editandoCategoria = categoria;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    cancelarEdicaoCategoria() {
      this.categoriaForm = { descricao: "", ativo: true };
      this.editandoCategoria = null;
    },
    editarProduto(produto) {
      this.produtoForm = {
        ...produto,
        imagemFile: null,
        itensPlanoIds: this.normalizarItensPlanoIdsDoProduto(produto),
        qtdDependentes: this.valorSelectNumeroOuVazio(produto.qtdDependentes),
        idadeMaxDependente: this.valorSelectNumeroOuVazio(produto.idadeMaxDependente),
        qtdAgregados: this.valorSelectNumeroOuVazio(produto.qtdAgregados),
        imagemPreview: produto.imagem
          ? (produto.imagem.startsWith("http")
              ? produto.imagem
              : (produto.imagem.startsWith("data:")
                  ? produto.imagem
                  : (produto.imagem.indexOf(".") !== -1 && produto.imagem.length < 200
                      ? `https://api.grupoparque.com.br/produtos/${produto.imagem}`
                      : `data:image/jpeg;base64,${produto.imagem}`)))
          : null,
        habilitarRetirada: produto.planoFunerario ? false : !!produto.habilitarRetirada,
        vincularFalecido: produto.planoFunerario ? false : !!produto.vincularFalecido,
      };
      this.editandoProduto = produto;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    cancelarEdicaoProduto() {
      this.produtoForm = {
        nome: "",
        descricao: "",
        tipo: "",
        valor: 0,
        qtdEstoque: 0,
        fornecedor: "",
        categoriaId: null,
        imagem: null,
        imagemPreview: null,
        imagemFile: null,
        ativo: true,
        destaque: false,
        planoFunerario: false,
        qtdDependentes: "",
        idadeMaxDependente: "",
        itensPlanoIds: [],
        qtdAgregados: "",
        habilitarRetirada: false,
        vincularFalecido: false,
      };
      this.removerImagem();
      this.editandoProduto = null;
    },
    /** Valor para select: número ou vazio (placeholder "Selecione...") */
    valorSelectNumeroOuVazio(val) {
      if (val === null || val === undefined || val === "") return "";
      const n = Number(val);
      return Number.isNaN(n) ? "" : n;
    },
    /** IDs dos itens de plano vindos da API (ids ou objetos) */
    normalizarItensPlanoIdsDoProduto(p) {
      if (!p) return [];
      if (Array.isArray(p.itensPlanoIds) && p.itensPlanoIds.length) {
        return p.itensPlanoIds.map((id) => Number(id)).filter((id) => !Number.isNaN(id));
      }
      if (Array.isArray(p.itensPlano) && p.itensPlano.length) {
        return p.itensPlano
          .map((i) => Number(i && (i.id != null ? i.id : i)))
          .filter((id) => !Number.isNaN(id));
      }
      return [];
    },
    normalizarItensPlanoIdsParaEnvio() {
      const raw = this.produtoForm.itensPlanoIds;
      if (!Array.isArray(raw) || !raw.length) return [];
      return raw.map((id) => Number(id)).filter((id) => !Number.isNaN(id));
    },
    normalizarNumeroOpcionalProduto(val) {
      if (val === "" || val === null || val === undefined) return null;
      const n = Number(val);
      return Number.isNaN(n) ? null : n;
    },
    onImageChange(event) {
      const file = event.target.files[0];
      if (file) {
        if (file.size > 5 * 1024 * 1024) {
          // 5MB
          this.mostrarDialog("Atenção", "A imagem deve ter no máximo 5MB");
          return;
        }

        this.produtoForm.imagemFile = file;

        const reader = new FileReader();
        reader.onload = (e) => {
          // Apenas para preview da imagem
          this.produtoForm.imagemPreview = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    removerImagem() {
      this.produtoForm.imagem = null;
      this.produtoForm.imagemPreview = null;
      this.produtoForm.imagemFile = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },
    verDetalhesVenda(venda) {
      this.$router.push(`/admin/venda/${venda.id}`);
    },
    formatPrice(value) {
      return new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleDateString("pt-BR");
    },
    logout() {
      authService.logout();
      this.$router.push("/login");
    },
    mostrarDialog(titulo, mensagem, tipo = "alert") {
      this.dialog = {
        show: true,
        titulo,
        mensagem,
        tipo,
        botaoTexto: "OK",
      };
    },
    onPlanoFunerarioChange() {
      if (this.produtoForm.planoFunerario) {
        this.produtoForm.habilitarRetirada = false;
        this.produtoForm.vincularFalecido = false;
      }
    },
    handleHabilitarRetiradaChange() {
      if (this.produtoForm.planoFunerario) return;
      if (this.produtoForm.habilitarRetirada) {
        this.produtoForm.vincularFalecido = false;
      }
    },
    handleVincularFalecidoChange() {
      if (this.produtoForm.planoFunerario) return;
      if (this.produtoForm.vincularFalecido) {
        this.produtoForm.habilitarRetirada = false;
      }
    },
    fecharDialog() {
      this.dialog.show = false;
    },
    onDialogConfirm() {
      this.fecharDialog();
    },
    getNomeCategoria(categoriaId) {
      if (!categoriaId) return '-';
      const categoria = this.categorias.find(cat => cat.id === categoriaId);
      return categoria ? categoria.descricao : '-';
    },
    editarStatusPedido(venda) {
      this.statusPedidoForm = {
        statusVenda: venda.statusVenda || venda.status_venda || '',
      };
      this.editandoStatusPedido = venda;
    },
    cancelarEdicaoStatusPedido() {
      this.editandoStatusPedido = null;
      this.statusPedidoForm = {
        statusVenda: '',
      };
    },
    async salvarStatusPedido() {
      try {
        await vendaService.atualizarStatusVenda(
          this.editandoStatusPedido.id,
          this.statusPedidoForm.statusVenda
        );
        await this.carregarDados();
        this.cancelarEdicaoStatusPedido();
        this.mostrarDialog('Sucesso', 'Status da venda atualizado com sucesso!');
      } catch (error) {
        this.mostrarDialog(
          'Erro',
          error.response?.data?.mensagem || error.message || 'Erro ao atualizar status da venda.'
        );
      }
    },
    getLabelStatusPedido(status) {
      const opcao = this.opcoesStatusPedido.find(opt => opt.value === status);
      if (opcao) return opcao.label;
      if (status === 'Enviado ao Jázigo') return 'Enviado ao Jázigo/Capela';
      return status;
    },
    getLabelFormaPagamento(forma) {
      if (!forma) return '-';
      const opcao = this.opcoesFormaPagamento.find(opt => opt.value === forma);
      if (opcao) return opcao.label;
      
      // Mapeamento direto para valores comuns da API
      const mapeamento = {
        'credit_card': 'Cartão de Crédito',
        'debit_card': 'Cartão de Débito',
        'pix': 'PIX',
        'boleto': 'Boleto',
        'cash': 'Dinheiro',
      };
      return mapeamento[forma] || forma;
    },
    getStatusPedidoClass(status) {
      const classes = {
        'em Análise': 'status-pendente',
        'Em Produção': 'status-processando_pagamento',
        'Produto Finalizado': 'status-pago',
        'Entregue': 'status-pago',
        'Enviado ao Jázigo': 'status-pago',
        'Enviado ao Jázigo/Capela': 'status-pago',
      };
      return classes[status] || 'status-pendente';
    },
    toggleMenu() {
      this.menuAberto = !this.menuAberto;
    },
    async abrirGerenciarUsuarios() {
      this.menuAberto = false;
      this.modalGerenciarUsuarios = true;
      await this.carregarUsuarios();
    },
    fecharModalGerenciarUsuarios() {
      this.modalGerenciarUsuarios = false;
    },
    async abrirCadastroUsuario() {
      this.modalCadastroUsuario = true;
      this.usuarioForm = {
        username: "",
        nome: "",
        email: "",
        telefone: "",
        senha: "",
        ativo: true,
        roleIds: [],
      };
      await this.carregarRoles();
    },
    fecharModalCadastroUsuario() {
      this.modalCadastroUsuario = false;
      this.usuarioForm = {
        username: "",
        nome: "",
        email: "",
        telefone: "",
        senha: "",
        ativo: true,
        roleIds: [],
      };
    },
    async abrirModalPermissoes(usuario) {
      this.modalAtualizarPermissoes = true;
      this.permissoesForm = {
        usuarioId: usuario.id,
        roleIds: usuario.roleIds ? [...usuario.roleIds] : (usuario.roles ? usuario.roles.map(r => r.id || r) : []),
      };
      await this.carregarRoles();
    },
    fecharModalPermissoes() {
      this.modalAtualizarPermissoes = false;
      this.permissoesForm = {
        usuarioId: null,
        roleIds: [],
      };
    },
    async carregarRoles() {
      if (this.roles.length > 0) return; // Já carregou
      this.carregandoRoles = true;
      try {
        this.roles = await roleService.listarRoles();
      } catch (error) {
        console.error("Erro ao carregar roles:", error);
        this.mostrarDialog("Erro", error.response?.data?.mensagem || "Erro ao carregar permissões.");
      } finally {
        this.carregandoRoles = false;
      }
    },
    abrirAlterarSenha() {
      this.menuAberto = false;
      this.modalAlterarSenha = true;
      this.senhaForm = {
        senhaAtual: "",
        novaSenha: "",
        confirmarSenha: "",
      };
    },
    fecharModalAlterarSenha() {
      this.modalAlterarSenha = false;
      this.senhaForm = {
        senhaAtual: "",
        novaSenha: "",
        confirmarSenha: "",
      };
    },
    async salvarUsuario() {
      if (!this.usuarioForm.senha || this.usuarioForm.senha.trim() === "") {
        this.mostrarDialog("Erro", "A senha é obrigatória.");
        return;
      }
      if (!this.usuarioForm.roleIds || this.usuarioForm.roleIds.length === 0) {
        this.mostrarDialog("Erro", "Selecione pelo menos uma permissão.");
        return;
      }
      try {
        await usuarioService.criarUsuario(this.usuarioForm);
        this.fecharModalCadastroUsuario();
        await this.carregarUsuarios();
        this.mostrarDialog("Sucesso", "Usuário cadastrado com sucesso!");
      } catch (error) {
        this.mostrarDialog("Erro", error.response?.data?.mensagem || "Erro ao cadastrar usuário.");
      }
    },
    async carregarUsuarios() {
      this.carregandoUsuarios = true;
      try {
        this.usuarios = await usuarioService.listarUsuarios();
      } catch (error) {
        console.error("Erro ao carregar usuários:", error);
        this.mostrarDialog("Erro", error.response?.data?.mensagem || "Erro ao carregar usuários.");
      } finally {
        this.carregandoUsuarios = false;
      }
    },
    async salvarPermissoes() {
      if (!this.permissoesForm.roleIds || this.permissoesForm.roleIds.length === 0) {
        this.mostrarDialog("Erro", "Selecione pelo menos uma permissão.");
        return;
      }
      try {
        await usuarioService.atualizarRoles(this.permissoesForm.usuarioId, this.permissoesForm.roleIds);
        this.fecharModalPermissoes();
        await this.carregarUsuarios();
        this.mostrarDialog("Sucesso", "Permissões atualizadas com sucesso!");
      } catch (error) {
        this.mostrarDialog("Erro", error.response?.data?.mensagem || "Erro ao atualizar permissões.");
      }
    },
    async alterarStatusUsuario(usuario) {
      try {
        await usuarioService.atualizarStatus(usuario.id, !usuario.ativo);
        await this.carregarUsuarios();
        this.mostrarDialog("Sucesso", `Usuário ${!usuario.ativo ? 'ativado' : 'inativado'} com sucesso!`);
      } catch (error) {
        this.mostrarDialog("Erro", error.response?.data?.mensagem || "Erro ao alterar status do usuário.");
      }
    },
    async salvarNovaSenha() {
      if (this.senhaForm.novaSenha !== this.senhaForm.confirmarSenha) {
        this.mostrarDialog("Erro", "As senhas não coincidem.");
        return;
      }
      try {
        await usuarioService.mudarSenha(this.senhaForm.senhaAtual, this.senhaForm.novaSenha);
        this.fecharModalAlterarSenha();
        this.mostrarDialog("Sucesso", "Senha alterada com sucesso!");
      } catch (error) {
        this.mostrarDialog("Erro", error.response?.data?.mensagem || "Erro ao alterar senha.");
      }
    },
    fecharMenuAoClicarFora(event) {
      if (!event.target.closest('.menu-dropdown')) {
        this.menuAberto = false;
      }
    },
    abrirTabItensPlano() {
      this.menuAberto = false;
      this.tabAtiva = 'itens-plano';
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
};
</script>

<style scoped>
.admin-page {
  min-height: 100vh;
  background: #f5f5f5;
}

.admin-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px 20px;
}

.admin-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
}

.admin-title {
  font-size: 32px;
  font-weight: 700;
  color: #111827;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.menu-dropdown {
  position: relative;
}

.btn-menu {
  background: #34894d;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-menu svg {
  width: 20px;
  height: 20px;
}

.btn-menu:hover {
  background: #2d7a42;
}

.dropdown-content {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  z-index: 1000;
  overflow: hidden;
}

.dropdown-item {
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: white;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #374151;
  transition: all 0.2s;
  text-decoration: none;
}

.dropdown-item svg {
  width: 18px;
  height: 18px;
  color: #6b7280;
}

.dropdown-item:hover {
  background: #f9fafb;
  color: #111827;
}

.dropdown-item:hover svg {
  color: #34894d;
}

.btn-logout {
  background: #dc2626;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-logout svg {
  width: 20px;
  height: 20px;
}

.btn-logout:hover {
  background: #ff0000;
}

.admin-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 32px;
  border-bottom: 2px solid #e5e7eb;
}

.tab-btn {
  padding: 12px 24px;
  border: none;
  background: transparent;
  color: #6b7280;
  font-weight: 500;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all 0.2s;
}

.tab-btn:hover {
  color: #34894d;
}

.tab-btn.active {
  color: #34894d;
  border-bottom-color: #34894d;
}

.admin-content {
  background: white;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.section-title {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 24px;
}

.admin-form {
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid #e5e7eb;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.form-group label {
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}

.form-input {
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s;
}

.form-input:focus {
  outline: none;
  border-color: #34894d;
  box-shadow: 0 0 0 3px rgba(52, 137, 77, 0.1);
}

.form-textarea {
  min-height: 90px;
  resize: vertical;
  font-family: inherit;
}

.field-hint {
  margin: 6px 0 0;
  font-size: 12px;
  color: #6b7280;
}

.itens-plano-checkboxes {
  max-height: 280px;
}

.item-destaque-mark {
  color: #ca8a04;
  margin-left: 4px;
  font-size: 0.9em;
}

.btn-save {
  background: #34894d;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-save:hover {
  background: #2d7a42;
}

.form-actions {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 8px;
}

.btn-cancel {
  background: transparent;
  color: #6b7280;
  border: 1px solid #d1d5db;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-cancel:hover {
  background: #f9fafb;
  border-color: #9ca3af;
  color: #374151;
}

.table-container {
  overflow-x: auto;
}

.admin-table {
  width: 100%;
  border-collapse: collapse;
}

.admin-table th {
  background: #f9fafb;
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 2px solid #e5e7eb;
}

.admin-table th.sortable {
  cursor: pointer;
  user-select: none;
  position: relative;
  transition: background-color 0.2s;
}

.admin-table th.sortable:hover {
  background: #f3f4f6;
}

.sort-icon {
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  color: #6b7280;
  vertical-align: middle;
}

.admin-table th.sortable:hover .sort-icon {
  color: #34894d;
}

.admin-table td {
  padding: 12px;
  border-bottom: 1px solid #e5e7eb;
  color: #4b5563;
}

.btn-edit,
.btn-view {
  background: #34894d;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-edit:hover,
.btn-view:hover {
  background: #2d7a42;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.status-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  margin-left: 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  border: 1px solid transparent;
}

.status-inativo {
  background: #fee2e2;
  color: #b91c1c;
  border-color: #fecaca;
}

.status-pendente {
  background: #fef3c7;
  color: #92400e;
}

.status-pago {
  background: #d1fae5;
  color: #065f46;
}
.status-processando_pagamento {
  background: #fef3c7;
  color: #998e2d;
}

.status-erro_pagamento {
  background: #fee2e2;
  color: #991b1b;
}

.image-preview {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.image-preview img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #d1d5db;
}

.btn-remove-image {
  background: #dc2626;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-remove-image:hover {
  background: #b91c1c;
}

.switch-label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  font-weight: 600;
  color: #374151;
  font-size: 14px;
  cursor: help;
  position: relative;
}

.info-icon {
  flex-shrink: 0;
  opacity: 0.6;
  transition: opacity 0.2s;
}

.switch-label:hover .info-icon {
  opacity: 1;
}

.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d1d5db;
  transition: 0.3s;
  border-radius: 24px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #34894d;
}

input:checked + .slider:before {
  transform: translateX(24px);
}

.slider:hover {
  background-color: #9ca3af;
}

input:checked + .slider:hover {
  background-color: #2d7a42;
}

.switch input:disabled + .slider {
  opacity: 0.5;
  cursor: not-allowed;
}

.switch input:disabled + .slider:hover {
  background-color: #d1d5db;
}

.switch input:checked:disabled + .slider {
  background-color: #9ca3af;
}

.switch input:checked:disabled + .slider:hover {
  background-color: #9ca3af;
}

.switch-text-muted {
  color: #9ca3af;
}

.section-subtitle {
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 24px;
  margin-top: -16px;
}

.agregados-section {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  margin-top: 16px;
  margin-bottom: 30px;
}

.agregados-section .section-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e5e7eb;
}

.text-muted {
  color: #9ca3af;
  font-size: 13px;
}

.text-center {
  text-align: center;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 12px;
  padding: 24px;
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.modal-large .modal-content {
  max-width: 1200px;
  width: 95%;
}

.modal-large-content {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.modal-body {
  flex: 1;
  overflow-y: auto;
  padding-top: 16px;
}

.modal-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #111827;
}

.btn-close-modal {
  background: transparent;
  border: none;
  font-size: 28px;
  color: #6b7280;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
}

.btn-close-modal:hover {
  background: #f3f4f6;
  color: #111827;
}

.itens-row {
  background: #f9fafb;
}

.itens-cell {
  padding: 20px !important;
  border-top: 2px solid #e5e7eb;
}

.itens-container {
  width: 100%;
}

.itens-title {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 16px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
}

.itens-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.item-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.2s;
}

.item-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-color: #34894d;
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f3f4f6;
}

.item-nome {
  font-size: 15px;
  color: #111827;
  flex: 1;
}

.item-quantidade {
  font-size: 14px;
  color: #6b7280;
  background: #f3f4f6;
  padding: 4px 12px;
  border-radius: 12px;
  font-weight: 600;
}

.item-details {
  display: flex;
  gap: 24px;
  margin-bottom: 8px;
}

.item-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.item-label {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}

.item-value {
  font-size: 14px;
  color: #111827;
  font-weight: 600;
}

.item-total {
  color: #34894d;
  font-size: 15px;
}

.item-detalhes {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  padding: 12px;
  background: #f0f9ff;
  border-left: 3px solid #34894d;
  border-radius: 4px;
  font-size: 13px;
  color: #1e40af;
}

.item-detalhes svg {
  flex-shrink: 0;
  margin-top: 2px;
  color: #34894d;
}

.item-detalhes strong {
  color: #111827;
  margin-right: 4px;
}

@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .modal-content {
    padding: 20px;
  }

  .item-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .item-details {
    flex-direction: column;
    gap: 12px;
  }
}

.action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.roles-checkboxes {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 300px;
  overflow-y: auto;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f9fafb;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: background-color 0.2s;
}

.checkbox-label:hover {
  background: #f3f4f6;
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #34894d;
}

.checkbox-label span {
  font-size: 14px;
  color: #374151;
  user-select: none;
}

/* Busca e Paginação */
.table-controls {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 16px;
}

.search-input {
  flex: 1;
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s;
}

.search-input:focus {
  outline: none;
  border-color: #34894d;
  box-shadow: 0 0 0 3px rgba(52, 137, 77, 0.1);
}

.margin-bottom {
  margin-bottom: 10px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 20px 0;
  margin-top: 16px;
}

.btn-pagination {
  background: white;
  color: #34894d;
  border: 1px solid #34894d;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-pagination:hover:not(:disabled) {
  background: #34894d;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(52, 137, 77, 0.2);
}

.btn-pagination:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  border-color: #d1d5db;
  color: #9ca3af;
}

.pagination-info {
  color: #6b7280;
  font-size: 14px;
  font-weight: 600;
  min-width: 150px;
  text-align: center;
}

.toggle-container {
  display: flex;
  align-items: center;
  gap: 12px;
  white-space: nowrap;
  cursor: pointer;
}

.toggle-label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  user-select: none;
}

@media (max-width: 768px) {
  .table-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .toggle-container {
    justify-content: space-between;
  }
}
</style>
